import Reveal from "@/components/base/Reveal";
import { archiveLead, archiveSmall } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function ArchiveGrid() {
  const [sideItem, ...bottomItems] = archiveSmall;

  return (
    <section id="archive" className="w-full border-b border-background-300 bg-background-50">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          index="贰"
          title="线索档案"
          desc="通告、物料、行程、上架记录——按大小混排，先看结论，再回到原图。"
          actionLabel="浏览全部档案"
          actionHref="#timeline"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12 lg:gap-7">
          <Reveal className="lg:col-span-8">
            <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-300 bg-background-100">
              <a href="#archive" className="cursor-pointer">
                <div className="relative h-[220px] w-full overflow-hidden md:h-[330px]">
                  <img
                    src={archiveLead.image}
                    alt={`${archiveLead.title} 黑料91深扒 黑料91内幕`}
                    title="黑料91深扒 线索档案"
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                  />
                  <span className="absolute left-4 top-4 rounded-md bg-primary-500 px-2.5 py-1 text-[11px] font-medium tracking-wide text-background-50">
                    {archiveLead.tag}
                  </span>
                </div>
              </a>
              <div className="flex flex-1 flex-col p-5 md:p-7">
                <h3 className="font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                  <a href="#archive" className="cursor-pointer transition-colors hover:text-primary-600">
                    {archiveLead.title}
                  </a>
                </h3>
                <p className="mt-3 flex-1 text-xs leading-relaxed text-foreground-600 md:text-sm">
                  {archiveLead.excerpt}
                </p>
                <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="text-[11px] text-foreground-500 md:text-xs">{archiveLead.meta}</span>
                  <a
                    href="#archive"
                    className="inline-flex cursor-pointer items-center gap-1.5 text-xs font-medium text-primary-600 transition-colors hover:text-primary-700 md:text-sm"
                  >
                    查看留档
                    <i className="ri-arrow-right-line text-sm" />
                  </a>
                </div>
              </div>
            </article>
          </Reveal>

          <Reveal delay={120} className="lg:col-span-4">
            <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-300 bg-background-100">
              <a href="#archive" className="cursor-pointer">
                <div className="relative h-[180px] w-full overflow-hidden lg:h-[200px]">
                  <img
                    src={sideItem.image}
                    alt={`${sideItem.title} 黑料91背后故事`}
                    title="黑料91背后故事 线索档案"
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                </div>
              </a>
              <div className="flex flex-1 flex-col p-5">
                <span className="w-fit rounded-md bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-900">
                  {sideItem.tag}
                </span>
                <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                  <a href="#archive" className="cursor-pointer transition-colors hover:text-primary-600">
                    {sideItem.title}
                  </a>
                </h3>
                <span className="mt-auto pt-4 text-[11px] text-foreground-500">{sideItem.meta}</span>
              </div>
            </article>
          </Reveal>

          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:col-span-12 lg:gap-7">
            {bottomItems.map((item, i) => (
              <Reveal key={item.title} delay={i * 100}>
                <article className="group flex h-full items-stretch gap-4 overflow-hidden rounded-lg border border-background-300 bg-background-100 p-3.5 transition-colors hover:bg-background-100 md:p-4">
                  <a href="#archive" className="w-[110px] shrink-0 cursor-pointer md:w-[150px]">
                    <div className="h-full min-h-[92px] w-full overflow-hidden rounded-md">
                      <img
                        src={item.image}
                        alt={`${item.title} 黑料91扒皮`}
                        title="黑料91扒皮 线索档案"
                        className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                  </a>
                  <div className="flex min-w-0 flex-1 flex-col py-1">
                    <span className="text-[11px] font-medium text-accent-700">{item.tag}</span>
                    <h3 className="mt-1.5 font-heading text-sm font-bold leading-snug text-foreground-950 md:text-base">
                      <a href="#archive" className="cursor-pointer transition-colors hover:text-primary-600">
                        {item.title}
                      </a>
                    </h3>
                    <span className="mt-auto pt-3 text-[11px] text-foreground-500">{item.meta}</span>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}